// src/components/home/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">BookDentist.pro</div>
            <div className="footer-tagline">
              Instant online booking for Open Dental practices
            </div>
          </div>

          <div className="footer-links-grid">
            <div className="footer-column">
              <div className="footer-column-title">Product</div>
              <ul className="footer-link-list">
                <li><a href="#features">Features</a></li>
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="/dentistjunobeach">Demo</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
                <li><a href="#faq">FAQ</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <div className="footer-column-title">Compare</div>
              <ul className="footer-link-list">
                <li><a href="#vs-nexhealth">vs NexHealth</a></li>
                <li><a href="#vs-weave">vs Weave</a></li>
                <li><a href="#vs-solutionreach">vs Solutionreach</a></li>
                <li><a href="#why-bookdentist">Why BookDentist.pro</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <div className="footer-column-title">Resources</div>
              <ul className="footer-link-list">
                <li><a href="#documentation">Documentation</a></li>
                <li><a href="#support">Support</a></li>
                <li><a href="#blog">Blog</a></li>
                <li><a href="#case-studies">Case Studies</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <div className="footer-column-title">Company</div>
              <ul className="footer-link-list">
                <li><a href="#about">About Us</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="#privacy">Privacy Policy</a></li>
                <li><a href="#terms">Terms of Service</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <div className="footer-copyright">
              © {currentYear} BookDentist.pro. All rights reserved.
            </div>
            <div className="footer-compliance">
              HIPAA Compliant • SOC 2 Type II Certified
            </div>
          </div>

          <div className="footer-bottom-right">
            <div className="footer-contact-info">
              <a href="mailto:support@bookdentist.pro">support@bookdentist.pro</a>
            </div>
          </div>
        </div>

        
      </div>
    </footer>
  );
};

export default Footer;